import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { motion } from 'framer-motion';
import { C, F, G, SH } from '../styles/tokens';

const QuerySupportSection = () => (
  <Box
    sx={{
      background: G.navyBlue,
      px:         { xs: 2, md: 4 },
      py:         { xs: 7, md: 9 },
      textAlign:  'center',
      position:   'relative',
      overflow:   'hidden',
    }}
  >
    {/* Decorative circles */}
    <Box sx={{ position: 'absolute', top: -80,  right: -80, width: 320, height: 320, borderRadius: '50%', background: 'rgba(245,158,11,0.07)',  pointerEvents: 'none' }} />
    <Box sx={{ position: 'absolute', bottom: -60, left: -60, width: 240, height: 240, borderRadius: '50%', background: 'rgba(255,255,255,0.04)', pointerEvents: 'none' }} />

    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
    >
      <Typography sx={{ fontFamily: F.heading, fontSize: 11, fontWeight: 700, letterSpacing: 3, textTransform: 'uppercase', color: C.amber, mb: 1.5 }}>
        We're Here to Help
      </Typography>

      <Typography sx={{ fontFamily: F.heading, fontSize: { xs: 30, md: 44 }, fontWeight: 800, color: C.white, lineHeight: 1.15, mb: 1.5 }}>
        Still have questions?
      </Typography>

      <Typography sx={{ fontFamily: F.body, fontSize: { xs: 15, md: 17 }, color: 'rgba(255,255,255,0.65)', mb: 4, maxWidth: 480, mx: 'auto', lineHeight: 1.7 }}>
        Our experts are just a message away. Reach out on WhatsApp and get clarity within minutes.
      </Typography>

      <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.97 }}>
        <Button
          component="a"
          href="https://wa.me/9311817126"
          target="_blank"
          rel="noopener noreferrer"
          variant="contained"
          size="large"
          startIcon={<WhatsAppIcon sx={{ fontSize: 22 }} />}
          sx={{
            backgroundColor: C.whatsapp,
            color:           C.white,
            fontFamily:      F.heading,
            fontWeight:      700,
            fontSize:        { xs: 14, md: 16 },
            px:              { xs: 3.5, md: 5 },
            py:              1.75,
            borderRadius:    '12px',
            boxShadow:       SH.btnGreen,
            '&:hover': { backgroundColor: C.whatsappDk, boxShadow: SH.btnGreenHover },
          }}
        >
          Connect on WhatsApp
        </Button>
      </motion.div>
    </motion.div>
  </Box>
);

export default QuerySupportSection;
